module.exports = __webpack_public_path__ + "static/media/My-contest-student.c4a9be58.png";